
import "./polyfills";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const _originalWarn = console.warn;
console.warn = (...args: unknown[]) => {
  if (typeof args[0] === "string" && args[0].includes("Sentry dropped")) return;
  _originalWarn.apply(console, args);
};

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  tracesSampleRate: 0,
  enableLogs: true
});

createRoot(document.getElementById("root")!).render(<App />);
  